import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

export interface CopyPlanParams {
  clientId: string;
  id: string;
  name: string;
  description?: string | null;
}

const copyPlan = (params: CopyPlanParams): Promise<string> =>
  authFetch('/Consumer/ManagePlans/CopyPlan', {
    method: 'POST',
    ...httpBodyOptions(params),
  });

export const useCopyPlanMutation = () => {
  return useMutation(copyPlan);
};
